import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@components/atoms/Button';

export interface TrialExpiredToastProps {
  /** Only the account owner can act on this, so only they get the call to action. */
  isOwner: boolean;
  /** Navigates to the paywall. Passed in because this renders outside the Router. */
  onChoosePlan: () => void;
}

/**
 * Body of the toast raised when the backend refuses a write because the organization's
 * free trial has expired.
 *
 * Copy is kept in sync with `organisms/TrialExpiredBanner` on purpose — a user can meet
 * this message either by landing on the dashboard or by having an action refused, and the
 * two should not read like two different problems.
 */
export const TrialExpiredToast: React.FC<TrialExpiredToastProps> = ({
  isOwner,
  onChoosePlan,
}) => (
  <div className="flex gap-3">
    <AlertTriangle
      className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-600 dark:text-amber-400"
      aria-hidden="true"
    />
    <div className="min-w-0">
      <p className="font-semibold text-amber-900 dark:text-amber-200">
        Your free trial has ended
      </p>
      <p className="mt-1 text-sm text-amber-800 dark:text-amber-300">
        Everything is still here and your team can keep reading. Creating and
        editing are paused until a payment method is added.
        {!isOwner && ' Ask the account owner to add one to restore full access.'}
      </p>

      {isOwner && (
        <Button onClick={onChoosePlan} className="mt-3">
          Choose a plan
        </Button>
      )}
    </div>
  </div>
);
